'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M7.19 11.476h8.381v2.095h-8.38v-2.095Zm2.096 8.381h-4.19V3.095h7.333v5.238h5.238v3.248l2.095-2.095v-2.2L13.476 1h-8.38A2.095 2.095 0 0 0 3 3.095v16.762c0 1.157.938 2.095 2.095 2.095h4.19v-2.095ZM7.19 17.762h4.296l.943-.943v-1.152H7.19v2.095Zm12.781-5.238c.105 0 .315.105.42.21l1.361 1.361c.21.21.21.629 0 .838l-1.047 1.048-2.2-2.2 1.047-1.048c.105-.104.21-.21.42-.21Zm0 4.086L13.581 23h-2.2v-2.2l6.39-6.39 2.2 2.2Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
});
var DocumentEditOutline = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.DocumentEditOutline = DocumentEditOutline;